module.exports = __webpack_public_path__ + "img/98.2.db00f139.png";